// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-page-from: #f7f9fe;
  --bg-page-to: #eef4fb;
  --surface: rgba(255, 255, 255, 0.84);
  --surface-solid: #ffffff;
  --hairline: rgba(15, 23, 42, 0.09);
  --hairline-strong: rgba(15, 23, 42, 0.16);
  --ink-900: #101828;
  --ink-800: #1f2937;
  --ink-700: #344054;
  --ink-500: #667085;
  --ink-400: #98a2b3;
  --primary-700: #1d4ed8;
  --primary-600: #2563eb;
  --primary-500: #3b82f6;
  --primary-100: #dbeafe;
  --primary-50: #eff6ff;
  --success-600: #059669;
  --success-50: #ecfdf5;
  --warning-600: #d97706;
  --warning-50: #fffbeb;
  --danger-600: #dc2626;
  --danger-50: #fef2f2;
  --shadow-card: 0 18px 44px -28px rgba(15, 23, 42, 0.36);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: var(--ink-800);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  background:
    radial-gradient(900px 520px at 8% -8%, rgba(59, 130, 246, 0.18), transparent 62%),
    radial-gradient(780px 480px at 94% 0%, rgba(20, 184, 166, 0.14), transparent 58%),
    linear-gradient(180deg, var(--bg-page-from), var(--bg-page-to));
  color: var(--ink-800);
}

button,
input,
select {
  font: inherit;
}

button {
  cursor: pointer;
}

.auth-missing,
.center {
  min-height: 100vh;
  display: grid;
  place-items: center;
  color: var(--ink-500);
}

.login-page {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 430px;
  gap: 24px;
  align-items: stretch;
  padding: 28px;
}

.user-login-page {
  grid-template-columns: minmax(320px, 420px);
  place-content: center;
  padding: 24px;
}

.user-login-card {
  width: 100%;
}

.login-showcase {
  min-height: calc(100vh - 56px);
  border-radius: 24px;
  padding: 34px;
  color: #fff;
  background:
    linear-gradient(135deg, rgba(14, 165, 233, 0.22), transparent 38%),
    linear-gradient(160deg, #0f1f42 0%, #153b75 52%, #0f766e 100%);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}

.brand,
.account,
.crumb,
.health-row,
.showcase-brand {
  display: flex;
  align-items: center;
}

.showcase-copy p {
  color: rgba(255, 255, 255, 0.68);
}

.showcase-copy h1 {
  max-width: 700px;
  margin: 14px 0 12px;
  font-size: clamp(36px, 6vw, 68px);
  line-height: 1.02;
  letter-spacing: 0;
}

.showcase-copy p {
  max-width: 620px;
  font-size: 16px;
  line-height: 1.8;
}

.showcase-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(130px, 1fr));
  gap: 1px;
  overflow: hidden;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.14);
}

.showcase-grid span,
.showcase-grid strong {
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.09);
}

.login-card {
  align-self: center;
  border: 1px solid var(--hairline);
  background: var(--surface);
  backdrop-filter: blur(18px);
  border-radius: 20px;
  padding: 26px;
  box-shadow: var(--shadow-card);
}

.login-card h2 {
  margin: 8px 0 6px;
  font-size: 26px;
}

.login-card p {
  margin: 0 0 22px;
  color: var(--ink-500);
  line-height: 1.7;
}

.login-form {
  display: grid;
  gap: 14px;
}

.login-form .btn {
  width: 100%;
  margin-top: 4px;
}

.captcha-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 190px 38px;
  gap: 8px;
  align-items: center;
}

.captcha-row img {
  width: 190px;
  height: 70px;
  border: 1px solid var(--hairline);
  border-radius: 10px;
  background: #fff;
}

.captcha-refresh {
  border: 1px solid var(--hairline);
  background: #fff;
}

.totp-box {
  display: grid;
  justify-items: center;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--hairline);
  border-radius: 12px;
  background: #fff;
}

.totp-box img {
  width: 220px;
  height: 220px;
}

.totp-box code {
  max-width: 100%;
  padding: 7px 9px;
  overflow-wrap: anywhere;
  border-radius: 8px;
  color: var(--ink-700);
  background: #f8fafc;
}

.error {
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 10px;
  color: var(--danger-600);
  background: var(--danger-50);
}

.login-alt {
  display: inline-flex;
  margin-top: 18px;
  color: var(--primary-700);
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.login-alt:hover {
  text-decoration: underline;
}

.shell {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 248px minmax(0, 1fr);
}

.side {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--hairline);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(20px);
}

.nav {
  flex: 1;
  padding: 18px 12px 8px;
}

.nav-label {
  padding: 12px 10px 7px;
  color: var(--ink-400);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 12px;
  border-radius: 9px;
  color: var(--ink-700);
  text-decoration: none;
  font-size: 13px;
  font-weight: 650;
}

.nav-link:hover,
.nav-link.active {
  background: linear-gradient(180deg, var(--primary-50), var(--primary-100));
  color: var(--primary-700);
}

.health {
  margin: 14px;
  padding: 14px;
  border: 1px solid var(--hairline);
  border-radius: 14px;
  background: #fff;
  box-shadow: var(--shadow-card);
}

.health-row {
  justify-content: space-between;
  color: var(--ink-500);
  font-size: 12px;
}

.mini-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--success-600);
}

.health strong {
  display: block;
  margin-top: 8px;
  font-size: 28px;
  color: var(--ink-900);
}

.health p {
  margin: 6px 0 0;
  color: var(--ink-500);
  font-size: 12px;
  line-height: 1.6;
}

.main {
  min-width: 0;
}

.top {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 14px;
  height: 58px;
  padding: 0 24px;
  border-bottom: 1px solid var(--hairline);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(18px);
}

.crumb {
  gap: 8px;
  color: var(--ink-500);
  font-size: 13px;
  font-weight: 650;
}

.spacer {
  flex: 1;
}

.account {
  gap: 9px;
}

.account img,
.account > span {
  width: 34px;
  height: 34px;
  border-radius: 10px;
}

.account > span {
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--primary-500), #14b8a6);
  color: white;
  font-weight: 800;
}

.account strong,
.account small {
  display: block;
}

.account strong {
  font-size: 13px;
}

.account small {
  color: var(--ink-500);
  font-size: 11px;
}

.icon-btn {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--ink-500);
}

.icon-btn:hover {
  background: #eef2f7;
  color: var(--ink-900);
}

.page {
  padding: 22px 24px 60px;
}

.head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--primary-700);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 800;
}

.head h1 {
  margin: 8px 0 6px;
  font-size: 26px;
  line-height: 1.2;
}

.head p {
  margin: 0;
  color: var(--ink-500);
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
}

.card {
  border: 1px solid var(--hairline);
  border-radius: 14px;
  background: var(--surface-solid);
  box-shadow: var(--shadow-card);
}

.kpi {
  padding: 18px;
}

.kpi-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: var(--primary-700);
  background: var(--primary-50);
}

.kpi-icon svg {
  width: 18px;
  height: 18px;
}

.kpi-icon.green {
  color: var(--success-600);
  background: var(--success-50);
}

.kpi-icon.amber {
  color: var(--warning-600);
  background: var(--warning-50);
}

.kpi-icon.red {
  color: var(--danger-600);
  background: var(--danger-50);
}

.kpi span {
  display: block;
  margin-top: 14px;
  color: var(--ink-500);
  font-size: 12px;
}

.kpi strong {
  display: block;
  margin-top: 5px;
  color: var(--ink-900);
  font-size: 30px;
}

.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 14px;
}

.two-col.one-wide {
  grid-template-columns: minmax(360px, 560px);
}

.form {
  padding: 18px;
  display: grid;
  gap: 13px;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--hairline);
}

label {
  display: grid;
  gap: 7px;
  color: var(--ink-700);
  font-size: 12px;
  font-weight: 700;
}

label.check {
  display: flex;
  align-items: center;
}

input,
select {
  height: 38px;
  border: 1px solid var(--hairline-strong);
  border-radius: 9px;
  padding: 0 11px;
  background: #fff;
  color: var(--ink-900);
  outline: none;
}

input:focus,
select:focus {
  border-color: var(--primary-500);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.14);
}

.btn {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 9px;
  font-weight: 800;
}

.btn.primary {
  color: #fff;
  background: linear-gradient(180deg, var(--primary-500), var(--primary-700));
}

.btn.secondary {
  color: var(--ink-700);
  background: #fff;
  border-color: var(--hairline-strong);
}

.btn.secondary:hover {
  color: var(--primary-700);
  border-color: rgba(37, 99, 235, 0.3);
  background: var(--primary-50);
}

.btn.danger {
  color: var(--danger-600);
  background: #fff;
  border-color: rgba(220, 38, 38, 0.24);
}

.btn.danger:hover {
  background: var(--danger-50);
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.btn.sm {
  height: 30px;
  padding: 0 10px;
  border-radius: 7px;
  font-size: 12px;
}

.notice {
  margin: 0 0 14px;
  padding: 10px 12px;
  border: 1px solid rgba(5, 150, 105, 0.18);
  border-radius: 10px;
  color: var(--success-600);
  background: var(--success-50);
  font-size: 13px;
  font-weight: 700;
}

.table-card {
  overflow: hidden;
}

.table-card .card-head {
  padding: 16px 18px;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

th,
td {
  padding: 13px 16px;
  text-align: left;
  border-bottom: 1px solid var(--hairline);
  vertical-align: middle;
}

th {
  color: var(--ink-500);
  background: #f8fafc;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

tr:last-child td {
  border-bottom: 0;
}

.table-input {
  width: 150px;
  height: 34px;
}

.table-input.wide {
  width: 240px;
}

.inline-check {
  min-width: 74px;
  gap: 6px;
  white-space: nowrap;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 260px;
}

.row-actions.compact {
  min-width: 140px;
}

.api-key-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 220px;
}

.api-key-cell code {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.api-key-hint {
  color: var(--ink-400);
  font-size: 11px;
  white-space: nowrap;
}

.api-guide {
  margin-bottom: 18px;
}

.api-guide-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.api-guide-head p {
  margin: 5px 0 0;
  color: var(--ink-500);
  font-size: 12px;
}

.api-endpoint-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 18px 16px;
}

.api-endpoint-row code {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  overflow: auto;
  border: 1px solid var(--hairline);
  border-radius: 9px;
  color: var(--ink-700);
  background: #f8fafc;
  white-space: nowrap;
}

.api-docs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  padding: 16px 18px 18px;
  border-top: 1px solid var(--hairline);
  background: #fbfdff;
}

.api-docs strong {
  color: var(--ink-800);
  font-size: 12px;
}

.api-docs p {
  margin: 6px 0 0;
  color: var(--ink-500);
  font-size: 12px;
  line-height: 1.6;
}

.api-docs pre {
  min-height: 78px;
  margin: 7px 0 0;
  padding: 10px 12px;
  overflow: auto;
  border-radius: 8px;
  color: #dbeafe;
  background: #172554;
  font: 11px/1.6 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.api-docs-note {
  grid-column: 1 / -1;
  margin: 0 !important;
  padding-top: 2px;
}

.muted {
  color: var(--ink-400);
}

.soft-inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--warning-600);
  font-size: 12px;
  font-weight: 800;
}

.tag {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.tag.pending {
  color: var(--warning-600);
  background: var(--warning-50);
}

.tag.calling {
  color: var(--primary-700);
  background: var(--primary-50);
}

.tag.answered {
  color: var(--success-600);
  background: var(--success-50);
}

.tag.no_answer,
.tag.cancelled {
  color: var(--danger-600);
  background: var(--danger-50);
}

.settings {
  padding: 18px;
}

.settings-form {
  max-width: 720px;
}

.settings-form label small,
.settings-readonly small {
  color: var(--ink-500);
  font-weight: 500;
  line-height: 1.6;
}

.settings-readonly {
  display: grid;
  gap: 6px;
  padding: 12px;
  border: 1px solid var(--hairline);
  border-radius: 10px;
  background: #f8fafc;
}

.settings-readonly span,
.settings-meta {
  color: var(--ink-500);
  font-size: 12px;
  font-weight: 700;
}

.settings-readonly strong {
  color: var(--ink-900);
}

.settings-meta {
  margin-top: 2px;
}

dl {
  margin: 0;
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 14px 20px;
}

dt {
  color: var(--ink-900);
  font-weight: 800;
}

dd {
  margin: 0;
  color: var(--ink-500);
}

.dial-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.dial-card {
  min-height: 170px;
  padding: 20px;
  border: 1px solid var(--hairline);
  border-radius: 14px;
  background: #fff;
  box-shadow: var(--shadow-card);
  text-align: left;
  transition: transform 160ms ease, border 160ms ease;
}

.dial-card:hover {
  transform: translateY(-2px);
  border-color: rgba(37, 99, 235, 0.35);
}

.dial-card:disabled {
  opacity: 0.68;
}

.dial-icon {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, var(--primary-500), #14b8a6);
}

.dial-card strong,
.dial-card small {
  display: block;
}

.dial-card strong {
  margin-top: 24px;
  font-size: 20px;
  color: var(--ink-900);
}

.dial-card small {
  margin-top: 7px;
  color: var(--ink-500);
}

.empty {
  grid-column: 1 / -1;
  padding: 24px;
  border: 1px dashed var(--hairline-strong);
  border-radius: 14px;
  color: var(--ink-500);
  background: rgba(255, 255, 255, 0.62);
}

@media (max-width: 980px) {
  .login-page,
  .shell,
  .two-col {
    grid-template-columns: 1fr;
  }

  .side {
    position: static;
    height: auto;
  }

  .nav {
    display: flex;
    overflow-x: auto;
  }

  .health {
    display: none;
  }

  .kpi-grid,
  .dial-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .api-docs {
    grid-template-columns: 1fr;
  }

  .api-docs-note {
    grid-column: auto;
  }
}

@media (max-width: 640px) {
  .login-page,
  .page {
    padding: 16px;
  }

  .login-showcase {
    min-height: 420px;
    padding: 24px;
  }

  .kpi-grid,
  .dial-grid {
    grid-template-columns: 1fr;
  }

  .top {
    padding: 0 14px;
  }

  .account small,
  .crumb {
    display: none;
  }

  .captcha-row {
    grid-template-columns: 1fr 38px;
  }

  .captcha-row img {
    grid-column: 1 / -1;
  }

  table {
    min-width: 760px;
  }

  .table-card {
    overflow-x: auto;
  }

  .api-guide-head,
  .api-endpoint-row {
    align-items: stretch;
    flex-direction: column;
  }

  .api-endpoint-row code {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,uDAAuD;EACvD,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB;;;mEAGiE;EACjE,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX;;kEAEgE;EAChE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0EAA0E;EAC1E,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gEAAgE;EAChE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2EAA2E;AAC7E;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,+EAA+E;EAC/E,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gEAAgE;AAClE;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[":root {\n  --bg-page-from: #f7f9fe;\n  --bg-page-to: #eef4fb;\n  --surface: rgba(255, 255, 255, 0.84);\n  --surface-solid: #ffffff;\n  --hairline: rgba(15, 23, 42, 0.09);\n  --hairline-strong: rgba(15, 23, 42, 0.16);\n  --ink-900: #101828;\n  --ink-800: #1f2937;\n  --ink-700: #344054;\n  --ink-500: #667085;\n  --ink-400: #98a2b3;\n  --primary-700: #1d4ed8;\n  --primary-600: #2563eb;\n  --primary-500: #3b82f6;\n  --primary-100: #dbeafe;\n  --primary-50: #eff6ff;\n  --success-600: #059669;\n  --success-50: #ecfdf5;\n  --warning-600: #d97706;\n  --warning-50: #fffbeb;\n  --danger-600: #dc2626;\n  --danger-50: #fef2f2;\n  --shadow-card: 0 18px 44px -28px rgba(15, 23, 42, 0.36);\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: var(--ink-800);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  background:\n    radial-gradient(900px 520px at 8% -8%, rgba(59, 130, 246, 0.18), transparent 62%),\n    radial-gradient(780px 480px at 94% 0%, rgba(20, 184, 166, 0.14), transparent 58%),\n    linear-gradient(180deg, var(--bg-page-from), var(--bg-page-to));\n  color: var(--ink-800);\n}\n\nbutton,\ninput,\nselect {\n  font: inherit;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.auth-missing,\n.center {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  color: var(--ink-500);\n}\n\n.login-page {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 430px;\n  gap: 24px;\n  align-items: stretch;\n  padding: 28px;\n}\n\n.user-login-page {\n  grid-template-columns: minmax(320px, 420px);\n  place-content: center;\n  padding: 24px;\n}\n\n.user-login-card {\n  width: 100%;\n}\n\n.login-showcase {\n  min-height: calc(100vh - 56px);\n  border-radius: 24px;\n  padding: 34px;\n  color: #fff;\n  background:\n    linear-gradient(135deg, rgba(14, 165, 233, 0.22), transparent 38%),\n    linear-gradient(160deg, #0f1f42 0%, #153b75 52%, #0f766e 100%);\n  box-shadow: var(--shadow-card);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.brand,\n.account,\n.crumb,\n.health-row,\n.showcase-brand {\n  display: flex;\n  align-items: center;\n}\n\n.showcase-copy p {\n  color: rgba(255, 255, 255, 0.68);\n}\n\n.showcase-copy h1 {\n  max-width: 700px;\n  margin: 14px 0 12px;\n  font-size: clamp(36px, 6vw, 68px);\n  line-height: 1.02;\n  letter-spacing: 0;\n}\n\n.showcase-copy p {\n  max-width: 620px;\n  font-size: 16px;\n  line-height: 1.8;\n}\n\n.showcase-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(130px, 1fr));\n  gap: 1px;\n  overflow: hidden;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.showcase-grid span,\n.showcase-grid strong {\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.09);\n}\n\n.login-card {\n  align-self: center;\n  border: 1px solid var(--hairline);\n  background: var(--surface);\n  backdrop-filter: blur(18px);\n  border-radius: 20px;\n  padding: 26px;\n  box-shadow: var(--shadow-card);\n}\n\n.login-card h2 {\n  margin: 8px 0 6px;\n  font-size: 26px;\n}\n\n.login-card p {\n  margin: 0 0 22px;\n  color: var(--ink-500);\n  line-height: 1.7;\n}\n\n.login-form {\n  display: grid;\n  gap: 14px;\n}\n\n.login-form .btn {\n  width: 100%;\n  margin-top: 4px;\n}\n\n.captcha-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 190px 38px;\n  gap: 8px;\n  align-items: center;\n}\n\n.captcha-row img {\n  width: 190px;\n  height: 70px;\n  border: 1px solid var(--hairline);\n  border-radius: 10px;\n  background: #fff;\n}\n\n.captcha-refresh {\n  border: 1px solid var(--hairline);\n  background: #fff;\n}\n\n.totp-box {\n  display: grid;\n  justify-items: center;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid var(--hairline);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.totp-box img {\n  width: 220px;\n  height: 220px;\n}\n\n.totp-box code {\n  max-width: 100%;\n  padding: 7px 9px;\n  overflow-wrap: anywhere;\n  border-radius: 8px;\n  color: var(--ink-700);\n  background: #f8fafc;\n}\n\n.error {\n  margin-top: 14px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  color: var(--danger-600);\n  background: var(--danger-50);\n}\n\n.login-alt {\n  display: inline-flex;\n  margin-top: 18px;\n  color: var(--primary-700);\n  font-size: 13px;\n  font-weight: 800;\n  text-decoration: none;\n}\n\n.login-alt:hover {\n  text-decoration: underline;\n}\n\n.shell {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 248px minmax(0, 1fr);\n}\n\n.side {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid var(--hairline);\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(20px);\n}\n\n.nav {\n  flex: 1;\n  padding: 18px 12px 8px;\n}\n\n.nav-label {\n  padding: 12px 10px 7px;\n  color: var(--ink-400);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 10px 12px;\n  border-radius: 9px;\n  color: var(--ink-700);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  background: linear-gradient(180deg, var(--primary-50), var(--primary-100));\n  color: var(--primary-700);\n}\n\n.health {\n  margin: 14px;\n  padding: 14px;\n  border: 1px solid var(--hairline);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: var(--shadow-card);\n}\n\n.health-row {\n  justify-content: space-between;\n  color: var(--ink-500);\n  font-size: 12px;\n}\n\n.mini-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--success-600);\n}\n\n.health strong {\n  display: block;\n  margin-top: 8px;\n  font-size: 28px;\n  color: var(--ink-900);\n}\n\n.health p {\n  margin: 6px 0 0;\n  color: var(--ink-500);\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.main {\n  min-width: 0;\n}\n\n.top {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  height: 58px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--hairline);\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(18px);\n}\n\n.crumb {\n  gap: 8px;\n  color: var(--ink-500);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.account {\n  gap: 9px;\n}\n\n.account img,\n.account > span {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n}\n\n.account > span {\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, var(--primary-500), #14b8a6);\n  color: white;\n  font-weight: 800;\n}\n\n.account strong,\n.account small {\n  display: block;\n}\n\n.account strong {\n  font-size: 13px;\n}\n\n.account small {\n  color: var(--ink-500);\n  font-size: 11px;\n}\n\n.icon-btn {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--ink-500);\n}\n\n.icon-btn:hover {\n  background: #eef2f7;\n  color: var(--ink-900);\n}\n\n.page {\n  padding: 22px 24px 60px;\n}\n\n.head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 18px;\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: var(--primary-700);\n  font-size: 11px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  font-weight: 800;\n}\n\n.head h1 {\n  margin: 8px 0 6px;\n  font-size: 26px;\n  line-height: 1.2;\n}\n\n.head p {\n  margin: 0;\n  color: var(--ink-500);\n}\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.card {\n  border: 1px solid var(--hairline);\n  border-radius: 14px;\n  background: var(--surface-solid);\n  box-shadow: var(--shadow-card);\n}\n\n.kpi {\n  padding: 18px;\n}\n\n.kpi-icon {\n  width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  color: var(--primary-700);\n  background: var(--primary-50);\n}\n\n.kpi-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.kpi-icon.green {\n  color: var(--success-600);\n  background: var(--success-50);\n}\n\n.kpi-icon.amber {\n  color: var(--warning-600);\n  background: var(--warning-50);\n}\n\n.kpi-icon.red {\n  color: var(--danger-600);\n  background: var(--danger-50);\n}\n\n.kpi span {\n  display: block;\n  margin-top: 14px;\n  color: var(--ink-500);\n  font-size: 12px;\n}\n\n.kpi strong {\n  display: block;\n  margin-top: 5px;\n  color: var(--ink-900);\n  font-size: 30px;\n}\n\n.two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.two-col.one-wide {\n  grid-template-columns: minmax(360px, 560px);\n}\n\n.form {\n  padding: 18px;\n  display: grid;\n  gap: 13px;\n}\n\n.card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--hairline);\n}\n\nlabel {\n  display: grid;\n  gap: 7px;\n  color: var(--ink-700);\n  font-size: 12px;\n  font-weight: 700;\n}\n\nlabel.check {\n  display: flex;\n  align-items: center;\n}\n\ninput,\nselect {\n  height: 38px;\n  border: 1px solid var(--hairline-strong);\n  border-radius: 9px;\n  padding: 0 11px;\n  background: #fff;\n  color: var(--ink-900);\n  outline: none;\n}\n\ninput:focus,\nselect:focus {\n  border-color: var(--primary-500);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.14);\n}\n\n.btn {\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  font-weight: 800;\n}\n\n.btn.primary {\n  color: #fff;\n  background: linear-gradient(180deg, var(--primary-500), var(--primary-700));\n}\n\n.btn.secondary {\n  color: var(--ink-700);\n  background: #fff;\n  border-color: var(--hairline-strong);\n}\n\n.btn.secondary:hover {\n  color: var(--primary-700);\n  border-color: rgba(37, 99, 235, 0.3);\n  background: var(--primary-50);\n}\n\n.btn.danger {\n  color: var(--danger-600);\n  background: #fff;\n  border-color: rgba(220, 38, 38, 0.24);\n}\n\n.btn.danger:hover {\n  background: var(--danger-50);\n}\n\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.62;\n}\n\n.btn.sm {\n  height: 30px;\n  padding: 0 10px;\n  border-radius: 7px;\n  font-size: 12px;\n}\n\n.notice {\n  margin: 0 0 14px;\n  padding: 10px 12px;\n  border: 1px solid rgba(5, 150, 105, 0.18);\n  border-radius: 10px;\n  color: var(--success-600);\n  background: var(--success-50);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.table-card {\n  overflow: hidden;\n}\n\n.table-card .card-head {\n  padding: 16px 18px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\nth,\ntd {\n  padding: 13px 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--hairline);\n  vertical-align: middle;\n}\n\nth {\n  color: var(--ink-500);\n  background: #f8fafc;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\ntr:last-child td {\n  border-bottom: 0;\n}\n\n.table-input {\n  width: 150px;\n  height: 34px;\n}\n\n.table-input.wide {\n  width: 240px;\n}\n\n.inline-check {\n  min-width: 74px;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.row-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 260px;\n}\n\n.row-actions.compact {\n  min-width: 140px;\n}\n\n.api-key-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 220px;\n}\n\n.api-key-cell code {\n  max-width: 170px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.api-key-hint {\n  color: var(--ink-400);\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.api-guide {\n  margin-bottom: 18px;\n}\n\n.api-guide-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.api-guide-head p {\n  margin: 5px 0 0;\n  color: var(--ink-500);\n  font-size: 12px;\n}\n\n.api-endpoint-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 18px 16px;\n}\n\n.api-endpoint-row code {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 12px;\n  overflow: auto;\n  border: 1px solid var(--hairline);\n  border-radius: 9px;\n  color: var(--ink-700);\n  background: #f8fafc;\n  white-space: nowrap;\n}\n\n.api-docs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  padding: 16px 18px 18px;\n  border-top: 1px solid var(--hairline);\n  background: #fbfdff;\n}\n\n.api-docs strong {\n  color: var(--ink-800);\n  font-size: 12px;\n}\n\n.api-docs p {\n  margin: 6px 0 0;\n  color: var(--ink-500);\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.api-docs pre {\n  min-height: 78px;\n  margin: 7px 0 0;\n  padding: 10px 12px;\n  overflow: auto;\n  border-radius: 8px;\n  color: #dbeafe;\n  background: #172554;\n  font: 11px/1.6 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.api-docs-note {\n  grid-column: 1 / -1;\n  margin: 0 !important;\n  padding-top: 2px;\n}\n\n.muted {\n  color: var(--ink-400);\n}\n\n.soft-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--warning-600);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.tag.pending {\n  color: var(--warning-600);\n  background: var(--warning-50);\n}\n\n.tag.calling {\n  color: var(--primary-700);\n  background: var(--primary-50);\n}\n\n.tag.answered {\n  color: var(--success-600);\n  background: var(--success-50);\n}\n\n.tag.no_answer,\n.tag.cancelled {\n  color: var(--danger-600);\n  background: var(--danger-50);\n}\n\n.settings {\n  padding: 18px;\n}\n\n.settings-form {\n  max-width: 720px;\n}\n\n.settings-form label small,\n.settings-readonly small {\n  color: var(--ink-500);\n  font-weight: 500;\n  line-height: 1.6;\n}\n\n.settings-readonly {\n  display: grid;\n  gap: 6px;\n  padding: 12px;\n  border: 1px solid var(--hairline);\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.settings-readonly span,\n.settings-meta {\n  color: var(--ink-500);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.settings-readonly strong {\n  color: var(--ink-900);\n}\n\n.settings-meta {\n  margin-top: 2px;\n}\n\ndl {\n  margin: 0;\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  gap: 14px 20px;\n}\n\ndt {\n  color: var(--ink-900);\n  font-weight: 800;\n}\n\ndd {\n  margin: 0;\n  color: var(--ink-500);\n}\n\n.dial-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.dial-card {\n  min-height: 170px;\n  padding: 20px;\n  border: 1px solid var(--hairline);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: var(--shadow-card);\n  text-align: left;\n  transition: transform 160ms ease, border 160ms ease;\n}\n\n.dial-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(37, 99, 235, 0.35);\n}\n\n.dial-card:disabled {\n  opacity: 0.68;\n}\n\n.dial-icon {\n  width: 46px;\n  height: 46px;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  color: #fff;\n  background: linear-gradient(135deg, var(--primary-500), #14b8a6);\n}\n\n.dial-card strong,\n.dial-card small {\n  display: block;\n}\n\n.dial-card strong {\n  margin-top: 24px;\n  font-size: 20px;\n  color: var(--ink-900);\n}\n\n.dial-card small {\n  margin-top: 7px;\n  color: var(--ink-500);\n}\n\n.empty {\n  grid-column: 1 / -1;\n  padding: 24px;\n  border: 1px dashed var(--hairline-strong);\n  border-radius: 14px;\n  color: var(--ink-500);\n  background: rgba(255, 255, 255, 0.62);\n}\n\n@media (max-width: 980px) {\n  .login-page,\n  .shell,\n  .two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .side {\n    position: static;\n    height: auto;\n  }\n\n  .nav {\n    display: flex;\n    overflow-x: auto;\n  }\n\n  .health {\n    display: none;\n  }\n\n  .kpi-grid,\n  .dial-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .api-docs {\n    grid-template-columns: 1fr;\n  }\n\n  .api-docs-note {\n    grid-column: auto;\n  }\n}\n\n@media (max-width: 640px) {\n  .login-page,\n  .page {\n    padding: 16px;\n  }\n\n  .login-showcase {\n    min-height: 420px;\n    padding: 24px;\n  }\n\n  .kpi-grid,\n  .dial-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .top {\n    padding: 0 14px;\n  }\n\n  .account small,\n  .crumb {\n    display: none;\n  }\n\n  .captcha-row {\n    grid-template-columns: 1fr 38px;\n  }\n\n  .captcha-row img {\n    grid-column: 1 / -1;\n  }\n\n  table {\n    min-width: 760px;\n  }\n\n  .table-card {\n    overflow-x: auto;\n  }\n\n  .api-guide-head,\n  .api-endpoint-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .api-endpoint-row code {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
